import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICookiePreferences } from "../../../Orchestrator/Types/Interface/ICookiePreferences";
import { saveCookieConsent, updateCookiePreferences } from "../../../Lib/Utils/CookieConsentUtils";

interface ISaveCookiePreferencesParams {
  preferences: Record<string, boolean>;
  cookieConsentGiven: boolean;
}

export class SaveCookiePreferencesAction extends BaseAction<void, ISaveCookiePreferencesParams> {
  override async run(): Promise<void> {
    try {
      const { preferences, cookieConsentGiven } = this.params!;

      const cookiePreferences: ICookiePreferences = {
        necessary: preferences.necessary || true, // Always true
        statistic: preferences.statistic || false,
        preferences: preferences.preferences || false,
        marketing: preferences.marketing || false,
      };

      if (cookieConsentGiven) {
        // User is updating existing preferences
        updateCookiePreferences(cookiePreferences);
      } else {
        // User is setting preferences for the first time
        saveCookieConsent(cookiePreferences);
        updateRecoilState('cookieConsentGivenAtom', true);
      }

      updateRecoilState('cookiePreferencesAtom', cookiePreferences);
      updateRecoilState('cookieConsentBannerVisibleAtom', false);
      updateRecoilState('cookieManagementModalVisibleAtom', false);
    } catch (error) {
      console.error("Error in SaveCookiePreferencesAction:", error);
    }
  }
} 